import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { emailMasking } from "../../../util/CommonReadonlyMasking";
import { ApplicationState } from "../../../store";
import * as MyAccountActions from "../../../store/myAccount/actions";
import { useForm, Controller } from "react-hook-form";
import * as httpClient from "../../../util/httpClient";
import { Notification } from "../../common/Notification";
import * as services from "../../../store/service";
import PhoneInput, { formatPhoneNumber, isValidPhoneNumber, parsePhoneNumber } from "react-phone-number-input";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";
import { isValidPhoneNo } from "../../../util/phoneNumberValidationUtil";
import { useTranslation } from "react-i18next";
import { GetCountryListAndInternationalSupport } from "../../../util/countryListAndInternationalSupport";

const TwoFactorAuth = (props: any) => {
    const { t: tLang } = useTranslation();
    const dispatch = useDispatch();
    const getAccountInformation = (forceReload?: boolean) => dispatch(MyAccountActions.actionCreators.getAccountInformation(forceReload));
    const [visibleEmail, setVisisbleEmail]: any = useState([]);
    const twoFactorAuthentication = useSelector((state: ApplicationState) =>
        state.myAccountServiceState
            ? state.myAccountServiceState._unifiedAccountInfo
                ? state.myAccountServiceState._unifiedAccountInfo._twoFactorAuthentication
                : null
            : null
    );
    const accountInfo = useSelector((state: ApplicationState) => (state.myAccountServiceState ? state.myAccountServiceState._unifiedAccountInfo : null));
    const [showEdit, setShowEdit] = useState(false);
    const [isLoading, setisLoading] = useState(false);
    const { supportInternational } = GetCountryListAndInternationalSupport();
    const contactPreference = useSelector((state: ApplicationState) =>
        state.myAccountServiceState
            ? state.myAccountServiceState._unifiedAccountInfo
                ? state.myAccountServiceState._unifiedAccountInfo._contactPreference
                : null
            : null
    );
    const personalAccountInformation = useSelector((state: ApplicationState) =>
        state.myAccountServiceState
            ? state.myAccountServiceState._unifiedAccountInfo
                ? state.myAccountServiceState._unifiedAccountInfo._personalAccountInformation
                : null
            : null
    );
    const businessInformation = useSelector((state: ApplicationState) =>
        state.myAccountServiceState
            ? state.myAccountServiceState._unifiedAccountInfo
                ? state.myAccountServiceState._unifiedAccountInfo._businessInformation
                : null
            : null
    );

    /**Validation with react-hook-form ***/
    const { errors, formState, handleSubmit, control, watch } = useForm({
        mode: "onSubmit",
        reValidateMode: "onChange",
    });

    const { isSubmitting } = formState;

    const setCountry = () => {
        if(!supportInternational && accountInfo!.country ==null){
            accountInfo!.country = "US";
        }
    };

    const showEditForm = () => {
        setCountry();
        setShowEdit(true);
    };

    const hideEditForm = () => {
        setShowEdit(false);
    };

    const save = (twoFactorAuth: any) => {
        setCountry();
        if (twoFactorAuth && contactPreference && personalAccountInformation && businessInformation && accountInfo) {
            setisLoading(true);
            services.GetAccountInformation().then((accountInfoResponse) => {
                const requestBody = {
                    MfaSmsNumber: twoFactorAuth.textSMSNumber
                        ? getCountryInfo()
                            ? twoFactorAuth.textSMSNumber.replace(/[^0-9+]/g, "")
                            : twoFactorAuth.textSMSNumber
                        : "",
                    MfaVoiceCallNumber: twoFactorAuth.phoneNumber
                        ? getCountryInfo()
                            ? twoFactorAuth.phoneNumber.replace(/[^0-9+]/g, "")
                            : twoFactorAuth.phoneNumber
                        : "",
                    IsEmailIdentityNotificationOptOut: contactPreference.idCrimeAndBreachNews,
                    IsEmailNotificationOptOut: contactPreference.alertNotification,
                    IsPushNotificationOptOut: contactPreference.appPushNotification,
                    IsSmsNotificationOptOut: contactPreference.textSMSNotification,

                    FirstName: personalAccountInformation.firstName,
                    LastName: personalAccountInformation.lastName,
                    MiddleName: personalAccountInformation.middleInitial,

                    Email: personalAccountInformation.primaryEmail,
                    Phone: personalAccountInformation.primaryPhone
                        ? getCountryInfo()
                            ? personalAccountInformation.primaryPhone.replace(/[^0-9+]/g, "")
                            : personalAccountInformation.primaryPhone
                        : personalAccountInformation.primaryPhone,

                    BusinessName: businessInformation.businessName,
                    EIN: accountInfoResponse._unifiedAccountInfo._businessInformation.ein
                        ? accountInfoResponse._unifiedAccountInfo._businessInformation.ein.replace("-", "")
                        : "",
                    FAX: businessInformation.fax,

                    PersonalSMS: contactPreference.smsNumber
                        ? getCountryInfo()
                            ? contactPreference.smsNumber.replace(/[^0-9+]/g, "")
                            : contactPreference.smsNumber
                        : contactPreference.smsNumber,
                    Address1: accountInfo.address1,
                    Address2: accountInfo.address2,
                    City: accountInfo.city,
                    State: accountInfo.state,
                    Country: accountInfo.country,
                    ZipCode: accountInfo.zipCode,
                };
                httpClient
                    .sendRequest("POST", "api/accountInfo/updateTwoFactorAuthInfo", requestBody)
                    .then((data) => {
                        setisLoading(false);
                        if (data.isSuccess) {
                            Notification({
                                type: "success",
                                title: tLang("manageAccount.myAccount.twoFactorAuth.notification.successTitle"),
                                message: tLang("manageAccount.myAccount.twoFactorAuth.notification.successMsg"),
                            });
                            getAccountInformation(true);
                            setShowEdit(false);
                        }
                    })
                    .catch(function (error) {
                        setisLoading(false);
                        Notification({
                            type: "error",
                            title: "Error",
                            message: error,
                            duration: 0,
                        });
                    });
            });
        }
    };

    const getCountryInfo = () => {
        let currentCountry = accountInfo && accountInfo.country ? accountInfo.country : "";
        if (currentCountry.includes("US") || currentCountry.includes("CA")) {
            return false;
        } else {
            return true;
        }
    };

    const toggleEmailVisibility = (item: any) => {
        if (visibleEmail.length > 0) {
            const index = visibleEmail.findIndex((element: any) => element.primaryEmail === item.primaryEmail);
            if (index >= 0) {
                visibleEmail.splice(index, 1);
                setVisisbleEmail([...visibleEmail]);
            } else {
                setVisisbleEmail([...visibleEmail, item]);
            }
        } else {
            setVisisbleEmail([...visibleEmail, item]);
        }
    };

    useEffect(() => {
        const elements = document.getElementsByClassName("PhoneInputCountry");

        if (elements && elements.length > 0) {
            let i = 1;
            try {
                for (const el of elements) {
                    const childs = el.children;
                    if (childs[0].nodeName === "SELECT") {
                        const selectEl = childs[0] as HTMLSelectElement;
                        i += 1;
                        selectEl.disabled = true;
                        selectEl.setAttribute("aria-label", `Phone number country${i}`);
                    }
                }
            } catch {}
        }
    }, [showEdit]);

    return (
        <React.Fragment>
            <div className="box offset-padding">
                <div className="box-header">
                    <div className="box-title-container">
                        <div className="box-title-icon" aria-hidden="true">
                            <em className="las la-lock"></em>
                        </div>
                        <div className="box-title-text has-actions">
                            <h2 className="box-title">{tLang("manageAccount.myAccount.twoFactorAuth.title")}</h2>
                        </div>
                    </div>
                    <div className="box-description">
                        <p>{tLang("manageAccount.myAccount.twoFactorAuth.description")}</p>
                    </div>
                    {!showEdit && (
                        <div className="box-actions">
                            <button type="button" className="btn-default btn-grey-dot" id="2fa" onClick={showEditForm}>
                                <span className="btn-text">
                                    {tLang("manageAccount.myAccount.twoFactorAuth.editButtonText")}{" "}
                                    <span className="sr-only">{tLang("manageAccount.myAccount.twoFactorAuth.title")}</span>
                                </span>
                                <span className="btn-icon">
                                    <RenderIcons iconName="pen" />
                                </span>
                            </button>
                        </div>
                    )}
                </div>
                <div className={isLoading ? "box-content loading" : "box-content"}>
                    {/* Grid Content */}
                    {!showEdit && twoFactorAuthentication && (
                        <div role="grid" className="data-grid " id="2fa-grid" aria-hidden="false">
                            <div role="row" className="data-row row">
                                <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="label-2fa-mobile-text-alerts">
                                        {tLang("manageAccount.myAccount.twoFactorAuth.label.2fa")}
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-8 col-no-gutter">
                                    <div role="gridcell" className="data-value" aria-labelledby="label-2fa-mobile-text-alerts">
                                        {twoFactorAuthentication.twoFactorAuth === true ? "ON" : "OFF"}
                                    </div>
                                </div>
                            </div>

                            <div role="row" className="data-row row">
                                <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="label-2fa-mobile-deliver-to1">
                                        {tLang("manageAccount.myAccount.twoFactorAuth.label.primaryEmail")}
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-8 col-no-gutter">
                                    <div role="gridcell" className="data-value" aria-labelledby="label-2fa-mobile-deliver-to1">
									    {twoFactorAuthentication.primaryEmail
                                        ? emailMasking(twoFactorAuthentication.primaryEmail)
										: ''}
                                    </div>
                                </div>
                            </div>

                            <div role="row" className="data-row row">
                                <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="label-2fa-mobile-text-sms">
                                        {tLang("manageAccount.myAccount.twoFactorAuth.label.textNsms")}
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-8 col-no-gutter">
                                    <div role="gridcell" className="data-value" aria-labelledby="label-2fa-mobile-text-sms">
                                        {twoFactorAuthentication && twoFactorAuthentication.mfaSMSNumber
                                            ? isValidPhoneNumber(twoFactorAuthentication.mfaSMSNumber)
                                                ? formatPhoneNumber(twoFactorAuthentication.mfaSMSNumber)
                                                : twoFactorAuthentication.mfaSMSNumber
                                            : "-"}
                                    </div>
                                </div>
                            </div>

                            <div role="row" className="data-row row">
                                <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="label-2fa-mobile-deliver-to">
                                        {tLang("manageAccount.myAccount.twoFactorAuth.label.phoneNumber")}
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-8 col-no-gutter">
                                    <div role="gridcell" className="data-value" aria-labelledby="label-2fa-mobile-deliver-to">
                                        {twoFactorAuthentication && twoFactorAuthentication.mfaVoiceCallNumber
                                            ? isValidPhoneNumber(twoFactorAuthentication.mfaVoiceCallNumber)
                                                ? formatPhoneNumber(twoFactorAuthentication.mfaVoiceCallNumber)
                                                : twoFactorAuthentication.mfaVoiceCallNumber
                                            : "-"}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {showEdit && twoFactorAuthentication && (
                        <div id="2fa-form">
                            <form action="#" id="2fa-form-container" onSubmit={handleSubmit(save)}>
                                <fieldset className="form-row inline">
                                        <div className="data-row row">
                                                <div className="col-xs-12 col-sm-4 col-no-gutter">
                                                    <div className="data-label" id="edit-2fa-mobile-text-alerts">
                                                            <label>{tLang("manageAccount.myAccount.twoFactorAuth.label.2fa")}</label>
                                                        </div>
                                                    </div>
                                                <div className="col-xs-12 col-sm-8 col-no-gutter">
                                                    <div className="data-value">
                                                            {twoFactorAuthentication.twoFactorAuth === true ? "ON" : "OFF"}
                                                        </div>
                                                    </div>
                                        </div>
                                    </fieldset>
                               
                                    <div id="2fa-mobile-text-alerts-option">
                                        <div className="form-row inline row">
                                            <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                                    <label>{tLang("manageAccount.myAccount.twoFactorAuth.label.primaryEmail")}</label>
                                                </div>
                                                <div className="form-input col-xs-12 col-sm-6 col-no-gutter">
                                                    <div
                                                        hidden={
                                                            !(
                                                                twoFactorAuthentication.primaryEmail === "" ||
                                                                visibleEmail.findIndex((element: any) => element.primaryEmail === twoFactorAuthentication.primaryEmail) >= 0
                                                            )
                                                        }
                                                    >
                                                        {twoFactorAuthentication.primaryEmail}
                                                    </div>
                                                    <div>
                                                        <span
                                                            hidden={
                                                                twoFactorAuthentication.primaryEmail === "" ||
                                                                visibleEmail.findIndex((element: any) => element.primaryEmail === twoFactorAuthentication.primaryEmail) >= 0
                                                            }
                                                            style={{ marginTop: "20px " }}
                                                        >
                                                            <p style={{ wordWrap: "break-word", maxWidth: "70vw" }}> {twoFactorAuthentication.primaryEmail ? emailMasking(twoFactorAuthentication.primaryEmail) : ''} </p>
                                                        </span>
                                                        <div className="form-input-button">
                                                            {twoFactorAuthentication.primaryEmail !== "" && (
                                                                <button
                                                                    type="button"
                                                                    className="btn-default btn-icon-only btn-no-padding"
                                                                    onClick={() => {
                                                                        toggleEmailVisibility(twoFactorAuthentication);
                                                                    }}
                                                                    title={
                                                                        visibleEmail.findIndex((element: any) => element.primaryEmail === twoFactorAuthentication.primaryEmail) < 0
                                                                            ? tLang("identityVault.monitoredInformation.businessInfoWidget.showEmailToolTip")
                                                                            : tLang("identityVault.monitoredInformation.businessInfoWidget.hideEmailToolTip")
                                                                    }
                                                                >
                                                                    <span className="btn-icon">
                                                                        <em
                                                                            className={`las ${visibleEmail.findIndex((element: any) => element.primaryEmail === twoFactorAuthentication.primaryEmail) < 0
                                                                                ? "la-eye"
                                                                                : "la-eye-slash"
                                                                                }`}
                                                                        ></em>
                                                                    </span>
                                                                    <span className="btn-text">Show / Hide Email Text</span>
                                                                </button>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div
                                                className={`form-row row ${errors["textSMSNumber"] && "status-error"} ${
                                                    errors["textSMSNumber"] && watch("textSMSNumber") && !parsePhoneNumber(watch("textSMSNumber")) ? "country-error" : ""
                                                }`}
                                            >
                                                <div className="form-row inline row">
                                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                                        <label htmlFor="2fa-text-sms-number">{tLang("manageAccount.myAccount.twoFactorAuth.label.textNsms")}</label>
                                                    </div>

                                                    <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                                                        <Controller
                                                            name={`textSMSNumber`}
                                                            control={control}
                                                            defaultValue={twoFactorAuthentication.mfaSMSNumber ? twoFactorAuthentication.mfaSMSNumber : ""}
                                                            className="inputbox"
                                                            rules={{
                                                                validate: (value) =>
                                                                    value ? isValidPhoneNo(accountInfo && accountInfo.country ? accountInfo.country : "US", value) : true,
                                                            }}
                                                            aria-label={tLang("manageAccount.myAccount.twoFactorAuth.label.textNsms") }
                                                            render={({ onChange, value }) => (
                                                                <PhoneInput
                                                                    value={value}
                                                                    onChange={onChange}
                                                                    international={false}
                                                                    addInternationalOption={false}
                                                                    defaultCountry={accountInfo && accountInfo.country ? accountInfo.country : "US"}
                                                                    countries={[accountInfo && accountInfo.country ? accountInfo.country : "US"]}
                                                                    id="2fa-text-sms-number"
                                                                    placeholder={tLang("manageAccount.myAccount.twoFactorAuth.placeholder.phoneNumber")}
                                                                    maxLength={15}
                                                                    aria-label={tLang("manageAccount.myAccount.twoFactorAuth.label.textNsms") }
                                                                />
                                                            )}
                                                        />
                                                        {!!errors["textSMSNumber"] && errors["textSMSNumber"].type === "validate" && (
                                                            <span className="form-error">
                                                                {tLang("manageAccount.myAccount.twoFactorAuth.validation.phoneNumber.invalid")}
                                                            </span>
                                                        )}
                                                        {!!errors["textSMSNumber"] &&
                                                            errors["textSMSNumber"].type === "minLength" &&
                                                            (getCountryInfo() ? (
                                                                <span className="form-error">
                                                                    {tLang("manageAccount.myAccount.twoFactorAuth.validation.phoneNumber.phoneNumberMinimum")}
                                                                </span>
                                                            ) : (
                                                                <span className="form-error">
                                                                    {tLang("manageAccount.myAccount.twoFactorAuth.validation.phoneNumber.phoneNumberInvalid")}
                                                                </span>
                                                            ))}
                                                        {!!errors["textSMSNumber"] &&
                                                            errors["textSMSNumber"].type === "maxLength" &&
                                                            (getCountryInfo() ? (
                                                                <span className="form-error">
                                                                    {tLang("manageAccount.myAccount.twoFactorAuth.validation.phoneNumber.phoneNumberMaximum")}
                                                                </span>
                                                            ) : (
                                                                <span className="form-error">
                                                                    {tLang("manageAccount.myAccount.twoFactorAuth.validation.phoneNumber.phoneNumberMinimum")}
                                                                </span>
                                                            ))}
                                                    </div>
                                                </div>
                                            </div>

                                            <div
                                                className={`form-row row ${errors["phoneNumber"] && "status-error"} ${
                                                    errors["phoneNumber"] && watch("phoneNumber") && !parsePhoneNumber(watch("phoneNumber")) ? "country-error" : ""
                                                }`}
                                            >
                                                <div className="form-row inline row">
                                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                                        <label htmlFor="2fa-phoneNumber">
                                                            {tLang("manageAccount.myAccount.twoFactorAuth.label.phoneNumber")}
                                                        </label>
                                                    </div>

                                                    <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                                                        <Controller
                                                            name={`phoneNumber`}
                                                            control={control}
                                                            defaultValue={twoFactorAuthentication.mfaVoiceCallNumber ? twoFactorAuthentication.mfaVoiceCallNumber : ""}
                                                            className="inputbox"
                                                            rules={{
                                                                validate: (value) =>
                                                                    value ? isValidPhoneNo(accountInfo && accountInfo.country ? accountInfo.country : "US", value) : true,
                                                            }}
                                                            aria-label={tLang("manageAccount.myAccount.twoFactorAuth.label.phoneNumber")}
                                                            render={({ onChange, value }) => (
                                                                <PhoneInput
                                                                    value={value}
                                                                    onChange={onChange}
                                                                    international={false}
                                                                    addInternationalOption={false}
                                                                    defaultCountry={accountInfo && accountInfo.country ? accountInfo.country : "US"}
                                                                    countries={[accountInfo && accountInfo.country ? accountInfo.country : "US"]}
                                                                    placeholder={tLang("manageAccount.myAccount.twoFactorAuth.placeholder.phoneNumber")}
                                                                    id="2fa-phoneNumber"
                                                                    maxLength={15}
                                                                    aria-label={tLang("manageAccount.myAccount.twoFactorAuth.label.phoneNumber")}
                                                                />
                                                            )}
                                                        />
                                                        {!!errors["phoneNumber"] && errors["phoneNumber"].type === "validate" && (
                                                            <span className="form-error">
                                                                {tLang("manageAccount.myAccount.twoFactorAuth.validation.phoneNumber.invalid")}
                                                            </span>
                                                        )}
                                                        {!!errors["phoneNumber"] &&
                                                            errors["phoneNumber"].type === "minLength" &&
                                                            (getCountryInfo() ? (
                                                                <span className="form-error">
                                                                    {tLang("manageAccount.myAccount.twoFactorAuth.validation.phoneNumber.phoneNumberMinimum")}
                                                                </span>
                                                            ) : (
                                                                <span className="form-error">
                                                                    {tLang("manageAccount.myAccount.twoFactorAuth.validation.phoneNumber.phoneNumberInvalid")}
                                                                </span>
                                                            ))}
                                                        {!!errors["phoneNumber"] &&
                                                            errors["phoneNumber"].type === "maxLength" &&
                                                            (getCountryInfo() ? (
                                                                <span className="form-error">
                                                                    {tLang("manageAccount.myAccount.twoFactorAuth.validation.phoneNumber.phoneNumberMaximum")}
                                                                </span>
                                                            ) : (
                                                                <span className="form-error">
                                                                    {tLang("manageAccount.myAccount.twoFactorAuth.validation.phoneNumber.phoneNumberInvalid")}
                                                                </span>
                                                            ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    <div className="margin-vertical-l"></div>
                                    <div className="row between-xs">
                                        <div className="col-xs col-no-gutter flex-grow-null"></div>
                                        <div className="col-xs col-no-gutter flex-grow-null">
                                            <ul className="list-inline list-reset">
                                                <li>
                                                    <button
                                                        type="button"
                                                        className="btn-default btn-link btn-no-padding btn-no-border btn-min-width"
                                                        onClick={() => hideEditForm()}
                                                    >
                                                        <span className="btn-text">{tLang("manageAccount.myAccount.twoFactorAuth.cancelButtonText")}</span>
                                                    </button>
                                                </li>
                                                <li className="margin-left-s">
                                                    <button type="submit" className="btn-default btn-primary btn-min-width" disabled={isSubmitting}>
                                                        <span className="btn-text">{tLang("manageAccount.myAccount.twoFactorAuth.saveButtonText")}</span>
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                            </form>
                        </div>
                    )}
                </div>
            </div>
        </React.Fragment>
    );
};

export default TwoFactorAuth;
